<template>
	<div class="clients">
    <v-app id="clients">
      <v-content>
        <v-layout align-center justify-center>
          <v-card-title><b>{{ $route.params.slug | uppercase }} Products</b></v-card-title>
        </v-layout>
        <v-container fluid fill-height>
          <v-layout>
            <div class="columns is-multiline">
              <div class="column is-3">
                <v-flex xs12>
                  <div class="label title is-3">Filters :</div>
                  <v-text-field v-model="search" append-icon="mdi-magnify" :label="'Search ' + '(' + filteredProducts.length + ') '+ $route.params.slug" single-line hide-details></v-text-field>
                  <v-select :items="province" label="By Province"></v-select>
                  <v-radio-group v-model="channel" column> 
                    <v-radio label="None" color="error" value="None"></v-radio>
                    <v-radio label="Products" color="secondary" value="Products"></v-radio>
                    <v-radio label="Events" color="orange" value="Events"></v-radio>
                    <v-radio label="Services" color="indigo" value="Services"></v-radio>
                  </v-radio-group>
                </v-flex>
              </div>
              <div class="column is-3" v-for="client in filteredClients" :key="client.id">
                <v-flex xs12>
                  <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                    <router-link :to="{
                      name: 'client',
                        params: {
                          slug: $route.params.slug,
                          client_slug: client.slug
                        }
                      }">
                      <v-img height="230" :src="getImage(client.images)"  responsive :lazy-src="getImage(client.images)">
                        <v-card-title style="word-break: normal">
                          {{ client.name }}
                        </v-card-title>
                      </v-img>
                    </router-link>
                    <v-card-text>
                      <div class="my-4 subtitle-1 black--text">
                        <span class="label">
                          {{ client.type }},  
                          {{ client.location }}
                        </span>
                      </div>
                      <v-layout align-center>
                        <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                        <div class="grey--text ml-4">4.5 (413)</div>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </div>
            </div>
          </v-layout>
        </v-container>
        <generalfab />
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name : "clients",
    data: () => ({
      nav_title: 'Clients Page',
      channel: 'None',
      province: ['All','Lusaka', 'Copperbelt', 'Central', 'Southern', 'Eastern', 'Western','North-Western', 'Luapula', 'Northern', 'Muchinga'],
      search: '',
    }),

    mounted() {
      this.initProductCategory(this.$route.params.slug)
    },

    computed: {
      ...mapState('mainCategory', ['products']),
      ...mapGetters({
        category: 'mainCategory/category'
      }),

      filteredProducts() {
        if (this.search) {
          const regexp = new RegExp(this.search, 'gi')
          return this.products.filter(product =>
            (product.name + product.client).match(regexp))
        }
        return this.products
      }
    },

    watch: {
      '$route.params.slug': () => {
        this.initProductCategory(this.$route.params.slug)
      },
      category() {
        if (this.category.id) {
          this.initProducte(this.category.id)
        }
      }
    },

    methods: {
      getImage(images){
        return images[0]
      },

      ...mapActions('mainCategory', 
        [ 
          'initProductCategory', 
          'initProducte'
        ]
      ),

      back(){
        this.$router.go(-1)
      }
    }
  }
</script>